import styled from 'styled-components'
import { Container } from '@util/standard';
import { colors, mediaQuery } from '@util/constants'

export const WhereToBuyListContainer = styled(Container)`
  display:grid;
  grid-template-columns:248px auto ;
  grid-gap:106px;
  ${mediaQuery.mediumDown}{
    grid-template-columns:1fr;
    grid-gap:30px;
  }
  ${mediaQuery.smallDown}{
    display:block;
  }
`

export const Filters = styled.div`
  ul{
    list-style-type:none;
    li{
      transition:opacity .25s;
      &:hover{
        opacity:0.5 ;
      }
      &:not(:last-child){
        margin-bottom:20px;
      }
    }
  }
`

export const StoreCardStyle = styled.li`
  display:grid;
  align-items:end;
  grid-template-columns:1fr 2fr ;
  border-bottom:2px solid ${colors.charcoal};
  padding:60px 30px;
  ${mediaQuery.wideDown}{
    grid-template-columns:1fr;
  }
  ${mediaQuery.mediumDown}{
    padding:30px;
  }
  ${mediaQuery.smallDown}{
    display:block;
  }
  &:not(:last-child){
    ${mediaQuery.mediumUp}{
      margin-bottom:30px;
    }
  }
  &:first-child{
    padding-top:0;
  }
  > div{
    
    // logo
    &:first-child{
      
      ${mediaQuery.wideDown}{
        grid-template-columns:1fr;
        justify-content:center;
        margin-bottom:30px;
      }
      [data-gatsby-image-wrapper]{
        max-width:200px;
        ${mediaQuery.wideDown}{
          margin:0 auto;
        }
      }
    }

    // buttons
    &:last-child{
      display:grid;
      grid-template-columns:auto auto;
      justify-content:flex-end ;
      ${mediaQuery.wideDown}{
        justify-content:center;
      }
      ${mediaQuery.smallDown}{
        grid-template-columns:1fr;
      }
      a{
        width:139px;
        text-align:center;
        > div{
          padding-top:12.1px;
          padding-bottom:12.1px;
        }
        &:last-child{
          ${mediaQuery.wideUp}{
            margin-left:15px;
          }
        }
        ${mediaQuery.wideDown}{
          margin:0 7.5px;
        }
        ${mediaQuery.smallDown}{
          margin:7.5px auto;
        }
      }
    }
  }
`